import React, { useEffect, useState } from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import { getWhatsAppOptions } from '../../services/whatsappService';
import { Grid, Select, MenuItem, ListItemText } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import { Facebook, WhatsApp } from '@material-ui/icons';
import HelpOutlineIcon from '@material-ui/icons/HelpOutline';
import { Instagram } from '@mui/icons-material';
import { i18n } from '../../translate/i18n';
import CancelIcon from '@mui/icons-material/Cancel';
import CheckIcon from '@mui/icons-material/Check';

const useStyles = makeStyles((theme) => ({
  online: {
    fontSize: 11,
    color: '#25d366',
  },
  offline: {
    fontSize: 11,
    color: '#e1306c',
  },
  paper: {
    borderRadius: 20,
    overflow: 'hidden',
    maxWidth: 440,
    width: '100%',
    boxShadow: '0 20px 60px rgba(0,0,0,0.15), 0 4px 20px rgba(0,0,0,0.08)',
  },
  header: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: theme.spacing(4, 3, 3),
    background: 'linear-gradient(160deg, #eff6ff 0%, #f0fdf4 100%)',
    borderBottom: '1px solid rgba(0,0,0,0.05)',
  },
  iconCircle: {
    width: 68,
    height: 68,
    borderRadius: '50%',
    background: '#ffffff',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    boxShadow: '0 4px 20px rgba(59,130,246,0.20)',
    marginBottom: theme.spacing(2),
    '& svg': {
      fontSize: 36,
      color: '#3b82f6',
    },
  },
  headerTitle: {
    fontWeight: 700,
    fontSize: '1.1rem',
    color: '#1e293b',
    textAlign: 'center',
    lineHeight: 1.4,
    letterSpacing: '-0.01em',
  },
  content: {
    padding: theme.spacing(3, 4, 2),
  },
  contentText: {
    fontSize: 14,
    color: '#64748b',
    lineHeight: 1.65,
    textAlign: 'center',
  },
  actions: {
    padding: theme.spacing(1, 3, 3),
    display: 'flex',
    justifyContent: 'center',
    gap: theme.spacing(1.5),
  },
  btnCancel: {
    borderRadius: 10,
    textTransform: 'none',
    fontWeight: 600,
    fontSize: 14,
    padding: theme.spacing(1, 2.5),
    backgroundColor: '#fee2e2',
    color: '#dc2626',
    boxShadow: 'none',
    minWidth: 130,
    '&:hover': {
      backgroundColor: '#fecaca',
      boxShadow: 'none',
    },
  },
  btnConfirm: {
    borderRadius: 10,
    textTransform: 'none',
    fontWeight: 600,
    fontSize: 14,
    padding: theme.spacing(1, 2.5),
    backgroundColor: '#16a34a',
    color: '#fff',
    boxShadow: 'none',
    minWidth: 130,
    '&:hover': {
      backgroundColor: '#15803d',
      boxShadow: 'none',
    },
  },
}));

const ConfirmationModal = ({
  title,
  children,
  open,
  onClose,
  onConfirm,
  isCellPhone,
  onSave,
  confirmLabel,
}) => {
  const classes = useStyles();
  const [selectedWhatsapp, setSelectedWhatsapp] = useState('');
  const [whatsapps, setWhatsapps] = useState([]);

  useEffect(() => {
    const delayDebounceFn = setTimeout(() => {
      const fetchWhatsapps = async () => {
        getWhatsAppOptions().then(({ data }) => setWhatsapps(data));
      };

      fetchWhatsapps();
    }, 500);
    return () => clearTimeout(delayDebounceFn);
  }, [open]);

  const IconChannel = (channel) => {
    switch (channel) {
      case 'facebook':
        return <Facebook style={{ color: '#3b5998', verticalAlign: 'middle' }} />;
      case 'instagram':
        return <Instagram style={{ color: '#e1306c', verticalAlign: 'middle' }} />;
      case 'whatsapp':
        return <WhatsApp style={{ color: '#25d366', verticalAlign: 'middle' }} />;
      default:
        return 'error';
    }
  };

  return (
    <Dialog
      open={open}
      onClose={() => onClose(false)}
      aria-labelledby="confirm-dialog"
      PaperProps={{ className: classes.paper }}
    >
      {/* Header with icon + title */}
      <Box className={classes.header}>
        <Box className={classes.iconCircle}>
          <HelpOutlineIcon />
        </Box>
        <Typography id="confirm-dialog" className={classes.headerTitle}>
          {title}
        </Typography>
      </Box>

      {/* Body */}
      <DialogContent className={classes.content}>
        <Typography className={classes.contentText}>{children}</Typography>

        {isCellPhone && (
          <Grid style={{ marginTop: 16 }} container>
            <Grid xs={12} item>
              <Select
                required
                fullWidth
                displayEmpty
                variant="outlined"
                value={selectedWhatsapp}
                onChange={(e) => setSelectedWhatsapp(e.target.value)}
                MenuProps={{
                  anchorOrigin: { vertical: 'bottom', horizontal: 'left' },
                  transformOrigin: { vertical: 'top', horizontal: 'left' },
                  getContentAnchorEl: null,
                }}
                renderValue={() => {
                  if (selectedWhatsapp === '') return 'Selecione uma Conexão';
                  const whatsapp = whatsapps.find((w) => w.id === selectedWhatsapp);
                  return whatsapp?.name;
                }}
              >
                {whatsapps?.length > 0 &&
                  whatsapps.map((whatsapp, key) => (
                    <MenuItem dense key={key} value={whatsapp.id}>
                      <ListItemText
                        primary={
                          <>
                            {IconChannel(whatsapp.channel)}
                            <Typography
                              component="span"
                              style={{
                                fontSize: 14,
                                marginLeft: 10,
                                display: 'inline-flex',
                                alignItems: 'center',
                                lineHeight: '2',
                              }}
                            >
                              {whatsapp.name}&nbsp;
                              <p
                                className={
                                  whatsapp.status === 'CONNECTED' ? classes.online : classes.offline
                                }
                              >
                                ({whatsapp.status})
                              </p>
                            </Typography>
                          </>
                        }
                      />
                    </MenuItem>
                  ))}
              </Select>
            </Grid>
          </Grid>
        )}
      </DialogContent>

      {/* Actions */}
      <DialogActions className={classes.actions} disableSpacing>
        <Button
          variant="contained"
          className={classes.btnCancel}
          startIcon={<CancelIcon />}
          onClick={() => onClose(false)}
        >
          {i18n.t('confirmationModal.buttons.cancel')}
        </Button>
        <Button
          variant="contained"
          className={classes.btnConfirm}
          startIcon={<CheckIcon />}
          onClick={() => {
            if (isCellPhone) onSave(selectedWhatsapp);
            onClose(false);
            onConfirm();
          }}
        >
          {confirmLabel ?? i18n.t('confirmationModal.buttons.confirm')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmationModal;
